import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import villa1 from "../../assets/projects/ongoing/villa1.jpeg";
import apartment1 from "../../assets/projects/ongoing/apartment1.jpeg";

const ongoingProjects = [
  {
    title: "Luxury Hotel Design",
    location: "Delhi NCR Sector 71",
    image: villa1,
  },
  {
    title: "Modern Apartment",
    location: "Noida",
    image: apartment1,
  },
];

export default function ProjectsOngoing() {

  const navigate = useNavigate();

  return (
    <section className="py-24 bg-[#FDFBF7] min-h-screen">

      <div className="max-w-7xl mx-auto px-6 md:px-16">

        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-8 text-[#2C2C2C] hover:text-[#C9A962] transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </button>

        <h1 className="text-4xl font-serif mb-12 text-center">
          Ongoing Projects
        </h1>

        <div className="grid md:grid-cols-3 gap-6">

          {ongoingProjects.map((project, index) => (

            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="overflow-hidden bg-white"
            >

              <img
                src={project.image}
                alt={project.title}
                className="w-full h-64 object-cover"
              />

              <div className="mt-4 p-4">

                <h3 className="font-serif text-xl">
                  {project.title}
                </h3>

                <p className="text-gray-500">
                  {project.location}
                </p>

                <span className="text-sm text-[#C9A962]">
                  Work In Progress
                </span>

              </div>

            </motion.div>

          ))}

        </div>

      </div>

    </section>
  );
}